var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup19964(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#68737a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224.393 -34.343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.393 39.343)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14,
    height: 14,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.745,10.126c-2.882,0-5.2,2.043-5.2,4.561s2.322,4.561,5.2,4.561a5.735,5.735,0,0,0,2.826-.728,3.166,3.166,0,0,0,1.987.364.146.146,0,0,0,.056-.266,2.154,2.154,0,0,1-.825-1.063,4.189,4.189,0,0,0,1.161-2.868C15.949,12.169,13.613,10.126,10.745,10.126Zm.35,6.408a.215.215,0,0,1-.21.21h-.518a.215.215,0,0,1-.21-.21V16.2a.215.215,0,0,1,.21-.21h.518a.215.215,0,0,1,.21.21Zm.825-2.029a1.418,1.418,0,0,1-.532.462.788.788,0,0,0-.238.252.992.992,0,0,0-.056.238.138.138,0,0,1-.14.126h-.644a.136.136,0,0,1-.14-.154.828.828,0,0,1,.126-.42,1.849,1.849,0,0,1,.5-.448.844.844,0,0,0,.294-.294.752.752,0,0,0,.112-.392.56.56,0,0,0-.126-.378.425.425,0,0,0-.35-.14.461.461,0,0,0-.308.112.4.4,0,0,0-.112.182.21.21,0,0,1-.21.154l-.6-.014a.129.129,0,0,1-.126-.14.948.948,0,0,1,.364-.728,1.582,1.582,0,0,1,.993-.294,1.487,1.487,0,0,1,1.035.336,1.132,1.132,0,0,1,.378.9A1.153,1.153,0,0,1,11.92,14.505ZM3.651,13.442A3.442,3.442,0,0,1,2.7,11.077,4.067,4.067,0,0,1,7,7.3a4.424,4.424,0,0,1,3.75,1.931h0a5.9,5.9,0,0,0-6.086,5.009h0a2.5,2.5,0,0,1-1.637.294.111.111,0,0,1-.042-.21A1.937,1.937,0,0,0,3.651,13.442Z",
    transform: "translate(-2.352 -6.945)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19964);
export default __webpack_public_path__ + "static/media/Group 19964.519ca62203eec58b0d60d0eece1097ec.svg";
export { ForwardRef as ReactComponent };